// UISource
// inputRule (1/2)
// shortcut "//"
// topBarButton
import analytics from '../cdpAnalytics'

export function analyticsInsertFriendlyFraction(UISource, numerator, denominator, inputRuleText) {
  analytics.track('Insert Fast Fraction', {
    UISource,
    numerator,
    denominator,
    inputRuleText,
  })
}
